import { Box, Skeleton } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import { IndicatorBlock } from './indicator-block'
import { useListingData } from '../../context/listing-data'
import { useListingActions } from '../../context/listing-actions'

export const AnalyticIndicators = () => {
  const { t } = useTranslation()

  const {
    viewCount = 0,
    applicationCount = 0,
    impressionCount = 0,
    chatCount = 0,
    loading
  } = useListingData()
  const { goToInsights, goToApplications, goToChat } = useListingActions()

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="flexStart"
      alignItems="center"
      gap="small"
      flexWrap="wrap"
    >
      {loading ? (
        <>
          <Skeleton.Shape width="150px" height="150px" />
          <Skeleton.Shape width="150px" height="150px" />
          <Skeleton.Shape width="150px" height="150px" />
          <Skeleton.Shape width="150px" height="150px" />
        </>
      ) : (
        <>
          <IndicatorBlock label={t('Impressions')} value={impressionCount} onClick={goToInsights} />
          <IndicatorBlock label={t('Views last 7 days')} value={viewCount} onClick={goToInsights} />
          <IndicatorBlock label={t('Leads')} value={chatCount} onClick={goToChat} />
          <IndicatorBlock
            label={t('Applications')}
            value={applicationCount}
            onClick={goToApplications}
          />
        </>
      )}
    </Box>
  )
}
